{{#if label}}
  <label for="{{id}}">{{t label}}</label>
{{/if}}
{{#if (equal helptext.position 'top')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}
<textarea {{#if attributes}}data-attributable{{/if}}>{{#if description}}{{t description}}{{/if}}</textarea>
{{#if (equal helptext.position 'bottom')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}